// Agenda collapsing
document.querySelectorAll('.clamped')
	.forEach(el => {
		const $parent = jQuery(el).closest('.clamp-wrap');
		if (el.scrollHeight > el.clientHeight) {
			const expandButton = document.createElement("button");
			expandButton.classList.add('btn-link');
			expandButton.classList.add('btn');
			expandButton.classList.add('expand-content');
			
			$parent.append(expandButton);
			expandButton.addEventListener('click', function(e) {
				e.stopPropagation();
				e.preventDefault();
				$parent.toggleClass('closed');
			});

		}
	})
